"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IWorkflow } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowsReturn = RequestsBaseReturn<PaginatedResponse<IWorkflow> | null>;

export interface UseGetWorkflowsProps extends RequestPagination {
  filters: IFilter<IWorkflow>[];
}

type GetAllSwrParams = [string, number, number, IFilter<IWorkflow>[]];

const useGetWorkflows = ({
  pageNumber,
  pageSize,
  filters,
}: UseGetWorkflowsProps): UseGetWorkflowsReturn => {
  // Remove normalization to allow multiple filters
  const processedFilters = filters?.length ? filters : [];

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IWorkflow>, Error, GetAllSwrParams>(
    [SWR_KEYS.getWorkflows, pageNumber, pageSize, processedFilters],
    ([, _pageNumber, _pageSize, _filters]) =>
      workflowService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflows;
